/* eslint eslint-comments/no-use: off */
/* To avoid a circular dependency between the timeline-items and issue viewer packages we can not colocate the fragments or put the fields next to where they are used. */

import {type PreloadedQuery, useQueryLoader} from 'react-relay'
import {graphql} from 'relay-runtime'

import type {secondaryTimelineQuery} from './__generated__/secondaryTimelineQuery.graphql'

export type PreloadedSecondaryQueryType = PreloadedQuery<secondaryTimelineQuery>
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
export const SecondaryTimelineGraphqlQuery = graphql`
  query secondaryTimelineQuery($nodes: [ID!]!) {
    nodes(ids: $nodes) {
      ... on ReferencedEvent {
        __id
        commit {
          abbreviatedOid
          hasSignature
          verificationStatus
          signature {
            __typename
            signer {
              login
              avatarUrl
            }
            state
            wasSignedByGitHub
            ... on SmimeSignature {
              issuer {
                commonName
                emailAddress
                organization
                organizationUnit
              }
              subject {
                commonName
                emailAddress
                organization
                organizationUnit
              }
            }
            ... on GpgSignature {
              keyId
            }
            ... on SshSignature {
              keyFingerprint
            }
          }
        }
      }
    }
  }
`
export function useSecondaryTimelineQuery() {
  const [secondaryTimelineQueryRef, loadSecondaryTimelineQueryRef, dispose] =
    useQueryLoader<secondaryTimelineQuery>(SecondaryTimelineGraphqlQuery)

  return {
    secondaryTimelineQueryRef,
    loadSecondaryTimelineQueryRef,
    dispose,
  }
}
